import React from 'react';
import classNames from 'classnames/bind';
import { Section } from "./components/Section";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var BundlePrice = function BundlePrice(_ref) {
  var bundlePrice = _ref.bundlePrice,
    benefit = _ref.benefit,
    bundlePriceHighlight = _ref.bundlePriceHighlight,
    benefitHighlight = _ref.benefitHighlight,
    bundlePriceTitle = _ref.bundlePriceTitle,
    benefitPriceTitle = _ref.benefitPriceTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement(Section, {
    highlightColor: bundlePriceHighlight,
    price: bundlePrice,
    title: bundlePriceTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('line')
  }), /*#__PURE__*/React.createElement(Section, {
    highlightColor: benefitHighlight,
    price: benefit,
    title: benefitPriceTitle
  }));
};